// import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import Typography from '@mui/joy/Typography'
import Stack from '@mui/joy/Stack'
import Tooltip from '@mui/joy/Tooltip'
import Chip from '@mui/joy/Chip'
import Card from '@mui/joy/Card'


import useAuth from 'hooks/useAuth'
// import usePayment from 'hooks/usePayment'
import useUserIdentity from 'hooks/useUserIdentity'
import { UserProps } from 'stores/user_store';


import { getIcon } from 'utils/misc'
// import Success from 'components/Success';
// import Error from 'components/Error';

const UserInfo = observer(({ user }: { user: UserProps }) => {
    const { currentUser } = useAuth();
    // const { refreshCurrentUser } = useAuth();
    const { currentIdentity } = useUserIdentity();
    // const { convertTaskToCredits } = usePayment();
    // const [converting, setConverting] = useState(false);
    const ClockIcon = getIcon('HourglassBottom');
    const EmailIcon = getIcon('MailOutline');
    const CheckIcon = getIcon('Check');


    /*
    function handleConvertTasksToCredits() {
        setConverting(true);
        convertTaskToCredits().then(() => {
            setTimeout(() => {
                refreshCurrentUser()
                    .then(() => {
                        setConverting(false);
                        Success("Great! It worked, you have an additional 20 minutes")
                    });
            }, 1000);
        })
            .catch((res) => {
                console.log(res);
                if(res.code == 429) {
                    Error("You can only convert 3 requests per day");
                }
                else {
                    Error("There was an error converting your request to minutes");
                }
            setConverting(false);
        });

    }
     */
    return (
        <Stack spacing={1}>
            <Card color="primary"  >


                <Stack>
                    <Typography
                        level="title-sm">Account Email
                    </Typography>
                    <Typography
                        level="body-xs"
                        startDecorator={<EmailIcon />}>{user.primary_email}
                    </Typography>

                </Stack>

                    { currentIdentity.role == "client" &&

                <Stack>

                    <Typography level="title-sm">Details</Typography>

                {currentUser.subscription_product != 'tasks' &&
                    <Stack

                        direction="row"
                        spacing={1}
                        alignItems="center">
                        <Tooltip placement="top" arrow title="Current credit balance.">
                            <Typography
                                level="body-xs"
                                startDecorator={<ClockIcon />}
                                endDecorator={
                                    <Chip
                                        size="sm"
                                        color={user.current_credit > 0 ? "success" : 'danger'}>
                                        {user.current_credit}
                                    </Chip>
                                }>
                                Minutes Remaining
                            </Typography>
                        </Tooltip>
                        </Stack>
                    }

                    <Stack direction="row"
                                spacing={1} alignItems="center">
                        <Tooltip arrow
                            title="How many requests are left (standard plans)">
                            <Typography
                                level="body-xs"
                                startDecorator={<CheckIcon />}
                                endDecorator={<Chip size="sm">{user.tasks_remaining}</Chip>}>
                                Requests
                            </Typography>
                            </Tooltip>

                            {/*
                        {currentUser.uuid == user.uuid && currentUser.tasks_remaining > 0 &&
                            <Tooltip arrow
                                title="Convert one of your Fancy Hands requests to minutes to use on the Day Ones service">
                                <Button
                                    variant="plain"
                                    color="primary"
                                    loading={converting}
                                    size="sm"
                                    onClick={handleConvertTasksToCredits}>
                                    Convert Request to Minutes
                                </Button>
                            </Tooltip>
                            }
                            */}

                    </Stack>

                </Stack>
                    }


            </Card>
        </Stack>
    );
});

export default UserInfo;
